module.exports = __webpack_public_path__ + "static/media/29.e59ae772.jpeg";